export default __webpack_public_path__ + "static/cancel-sub-2eb7bbd033af02bf90b83e335401ca41.png";